var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FootnoteReferencesActionTypes } from './actions';
const updateReferences = (state, refId, addend = 1) => {
    const { references } = state;
    const reference = references.find((referencesItem) => referencesItem.id === refId);
    if (reference) {
        reference.count += addend;
    }
    else {
        references.push({ id: refId, count: 1 });
    }
    return references.filter((referencesItem) => referencesItem.count > 0);
};
const updateReferenceServiceData = (footnoteReferenceService, references) => {
    footnoteReferenceService.removeFootnoteReferences();
    const footnotes = references.map((reference) => reference.id);
    footnoteReferenceService.addFootnoteReferences(footnotes);
};
const setReferenceNumbers = (existingRefs, numberedRefs, usesScopeLocalNumbering = false) => {
    const withGlobal = existingRefs.map((reference) => {
        var _a;
        const numberedRef = numberedRefs.find((n) => n.id === reference.id);
        return Object.assign(Object.assign({}, reference), { globalNumber: (_a = numberedRef === null || numberedRef === void 0 ? void 0 : numberedRef.number) !== null && _a !== void 0 ? _a : -1, contextId: numberedRef === null || numberedRef === void 0 ? void 0 : numberedRef.contextID });
    });
    if (!usesScopeLocalNumbering) {
        return withGlobal.map((_a) => {
            var { globalNumber } = _a, reference = __rest(_a, ["globalNumber"]);
            return (Object.assign(Object.assign({}, reference), { number: globalNumber }));
        });
    }
    const localNumberMap = new Map();
    [...withGlobal]
        .filter((ref) => ref.globalNumber > 0)
        .sort((a, b) => a.globalNumber - b.globalNumber)
        .forEach((ref, index) => localNumberMap.set(ref.id, index + 1));
    return withGlobal.map((_a) => {
        var _b;
        var { globalNumber } = _a, reference = __rest(_a, ["globalNumber"]);
        return (Object.assign(Object.assign({}, reference), { number: (_b = localNumberMap.get(reference.id)) !== null && _b !== void 0 ? _b : -1 }));
    });
};
export const footnoteReferenceReducer = (state, action) => {
    switch (action.type) {
        case FootnoteReferencesActionTypes.AddFootnoteReference: {
            const newReferences = updateReferences(state, action.payload);
            updateReferenceServiceData(state.footnoteReferenceService, newReferences);
            return Object.assign(Object.assign({}, state), { references: newReferences });
        }
        case FootnoteReferencesActionTypes.RemoveFootnoteReference: {
            const newReferences = updateReferences(state, action.payload, -1);
            updateReferenceServiceData(state.footnoteReferenceService, newReferences);
            return Object.assign(Object.assign({}, state), { references: newReferences });
        }
        case FootnoteReferencesActionTypes.SetFootnoteReferencesNumbers: {
            const newReferences = setReferenceNumbers(state.references, action.payload, state.usesScopeLocalNumbering);
            return Object.assign(Object.assign({}, state), { references: newReferences });
        }
        default: {
            return state;
        }
    }
};
